export default __webpack_public_path__ + "static/media/p9_publisher4.64ff677b.png";